export default __webpack_public_path__ + "static/media/mobileFaderImage2.6cee36c0.png";